import { REGION_CODE } from './regions';

const initialStateV2 = {
  // New structured slices — empty but correctly shaped
  routes: {
    cart: {},
    checkout: {},
    receipt: {},
  },

  apiData: {
    cart: undefined,
    checkout: undefined,
    receipt: undefined,
    // Raw API JSON payloads inserted at runtime by API calls
  },

  hydrated: {
    cart: false,
    checkout: false,
    // Receipt always passes through the ReceiptRouteElement gate immediately.
    // Data is fetched by useReceiptData (full hydration) or pre-populated into
    // apiData.receipt before SPA navigation (partial hydration from checkout).
    receipt: true,
  },

  // Legacy fallback shape for backwards-compatible access
  nonCC: false,
  accountEmail: null,
  expressStatesBlacklist: [],
  billingCountries: [],
  profile: null,
  isMultiProfileAccount: false,
  isChipUpgrade: false,
  shippingCountries: [],
  hasSavedCreditCard: false,
  account: { isAuthenticated: false, paymentMethods: [], addresses: [] } as IAccount,
  address: {},
  billing: {},
  cart: {},
  cartConfig: { availableProducts: [], maxTotalItems: 10 } as CartConfig,
  confirmation: { body: '', title: '' },
  kit: {},
  displayAuthenticationWindow: false,
  editableClass: '',
  error: {
    backTo: '',
    body: '',
    button: '',
    countryCode: '',
    method: '',
    step: '',
    title: '',
  },
  hasSubscribedProfile: false,
  hideUkPromoPricing: false,
  showUkShippingUpdate: false,
  showIntShippingUpdate: false,
  isBillingPromo: false,
  isSubsEnabled: false,
  premiumNamingEnabled: false,
  isPrepaidSubscription: false,
  hasTotalHealth: false,
  hasTotalHealthUpgrade: false,
  isPremiumAncestry: false,
  isEmptyCart: false,
  hasPendingTotalHealth: false,
  hasDiscountedPrepaidSubscription: false,
  isApiUp: false,
  loading: false,
  paymentMethod: null,
  profiles: [],
  shipMethod: {},
  shippingMethods: [],
  shippingStates: [],
  billingStates: [],
  showCookieBanner: false,
  step: '',
  verifiedAddress: null,
  showOrderDetails: false,
  modalOpen: '',
  isProcessing: false,
  pubUrl: '',
  planId: null,
  subscriptionInfo: {},
  // BKO-4810: typed non-null defaults so hydration never skips them (mergeWith drops
  // undefined; a null seed would survive and crash the picker). See AGENTS.md.
  eligiblePlans: [],
  selectedPlanId: '',
  subBundleInfo: {},
  billingInfo: {},
  openSubsTab: '',
  hasSurveyResults: false,
  successUrl: '',
  isMobileWebView: false,
  heapId: '',
  region: REGION_CODE,
  labs: {},
  clinic: {},
  enablePaypal: false,
  enableSavedPaymentsPaypal: false,
  enableVenmo: false,
  enableApplepay: false,
  enableGooglePay: false,
  gtmNullPayload: null,
  braintreeToken: null,
  paypalClientId: null,
  // Typed default, not null: mergeWith skips absent keys so a null seed survives hydration.
  googlePayMerchantId: '',
  areHostedFieldsPopulated: false,
  braintreeInstance: null,
  inputFields: null,
  orderCreationDate: null,
  preserveDefaultPayment: false,
  showHistoricalMatches: false,
  upsellSource: null,
  // BKO-5140: server hydrates the resolved variant; seed a valid default (never null).
  upgradeSource: 'biogeography',
  utmData: null,
};

export default initialStateV2;
